import { useQuery } from '@tanstack/react-query'
import { labelsApi } from '../../../api/labels.api'
import { Badge } from '../../../components/ui/Badge'
import formStyles from '../../../components/ui/Form.module.css'

export function LabelPicker({ projectId, selectedIds, onToggle }: { projectId: string; selectedIds: string[]; onToggle: (id: string) => void }) {
  const { data } = useQuery({ queryKey: ['labels', projectId], queryFn: async () => (await labelsApi.list(projectId)).data })

  if (!data || data.length === 0) {
    return <span style={{ color: 'var(--text-muted)', fontSize: 'var(--text-sm)' }}>Keine Labels vorhanden.</span>
  }

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 'var(--space-2)' }}>
      {data.map((label) => (
        <label
          key={label.id}
          className={formStyles.checkboxRow}
          style={{ border: '1px solid var(--surface-border)', borderRadius: 'var(--radius-md)', padding: '4px 10px' }}
        >
          <input type="checkbox" checked={selectedIds.includes(label.id)} onChange={() => onToggle(label.id)} />
          <Badge style={{ background: `${label.color}22`, color: label.color }}>{label.name}</Badge>
        </label>
      ))}
    </div>
  )
}
